import { render } from "./UpdatesCard.vue?vue&type=template&id=4c0a2116&scoped=true"
import script from "./UpdatesCard.vue?vue&type=script&lang=js"
export * from "./UpdatesCard.vue?vue&type=script&lang=js"

import "./UpdatesCard.vue?vue&type=style&index=0&id=4c0a2116&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c0a2116"]])

export default __exports__